import { useEffect, useState } from 'react';
import {
  MINUTE_IN_MS,
  getMiddayTimestamp,
  SECOND_IN_MS,
  floorTimestamp,
} from '../../common/utils/time';

export const useDate = (checkTimeout: number = MINUTE_IN_MS): Date => {
  const [timestamp, setTimestamp] = useState(getMiddayTimestamp());

  useEffect(() => {
    const check = setInterval(
      () => setTimestamp(getMiddayTimestamp()),
      checkTimeout
    );
    return () => clearInterval(check);
  }, [checkTimeout]);

  return new Date(timestamp);
};

export const useDateTime = (updatePeriod: number = SECOND_IN_MS): Date => {
  const [timestamp, setTimestamp] = useState(+new Date());

  useEffect(() => {
    const update = setInterval(
      () => setTimestamp(floorTimestamp(new Date(), updatePeriod)),
      updatePeriod
    );
    return () => clearInterval(update);
  }, [updatePeriod]);

  return new Date(timestamp);
};
